const ENV_NAME = 'dev';
const  IDLE_WARNING_DURATION = 840000;
const  IDLE_TIMEOUT_DURATION = 60000;

const LAMBDA_API_URL_01 = 'https://dev-sls01.medrecordexchange.com/api/';
const LAMBDA_API_URL_02 = 'https://dev-sls02.medrecordexchange.com/api/';
const LAMBDA_API_URL_03 = 'https://dev-sls03.medrecordexchange.com/api/';
const LAMBDA_API_URL_04 = 'https://dev-sls04.medrecordexchange.com/api/';
const LAMBDA_API_URL_05 = 'https://dev-sls05.medrecordexchange.com/api/';
const LAMBDA_API_URL_06 = 'https://dev-sls06.medrecordexchange.com/api/';
const PHP_API_URL = 'https://dev-api.medrecordexchange.com/';
const PHP_AHS_API_URL = 'https://api.medrecordexchange.com/dev/ahs_php/';
const TRANSCRIBE_API_URL = 'https://ahsgpt.medrecordexchange.com/';
const VIDEO_API_URL = 'https://videosummerize.medrecordexchange.com/';


export const environment = {
  production: false,
  environmentName: ENV_NAME,
  lambdaApiUrl_01: LAMBDA_API_URL_01,
  lambdaApiUrl_02: LAMBDA_API_URL_02,
  lambdaApiUrl_03: LAMBDA_API_URL_03,
  lambdaApiUrl_04: LAMBDA_API_URL_04,
  lambdaApiUrl_05: LAMBDA_API_URL_05,
  lambdaApiUrl_06: LAMBDA_API_URL_06,
  phpApiUrl: PHP_API_URL,
  phpAhsApiUrl: PHP_AHS_API_URL,
  idleWarningDuration: IDLE_WARNING_DURATION ,
  idleTimeoutDuration: IDLE_TIMEOUT_DURATION,
  transcribeApiUrl: TRANSCRIBE_API_URL,
  videoApiUrl: VIDEO_API_URL
};
